import React from 'react';
import { Box, Text } from '@razorpay/blade/components';
import { toIndianCurrencyString } from 'utils/Numbers';
import styled from 'styled-components';

type PayableTaxPercentProps = {
  regime: string;
  tax: number;
  percent: number;
  variant?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export const PayableTaxWrapper = styled.div<{ variant: string; width: number }>(
  ({ theme, variant, width }) => `
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    min-width: 250px;
    justify-content: space-between;
    cursor: pointer;
    gap: ${theme.spacing[6]}px;
    padding: ${theme.spacing[6]}px ${theme.spacing[7]}px;
    border-radius: ${theme.border.radius.none}px ${theme.border.radius.large}px ${theme.border.radius.large}px ${theme.border.radius.none}px;
    border-top: ${theme.border.width.thin}px solid ${
      variant === 'grey'
        ? theme.colors.surface.border.gray.subtle
        : theme.colors.feedback.border.positive.subtle
    };
    border-right: ${theme.border.width.thin}px solid ${
      variant === 'grey'
        ? theme.colors.surface.border.gray.subtle
        : theme.colors.feedback.border.positive.subtle
    };
    border-bottom: ${theme.border.width.thin}px solid ${
      variant === 'grey'
        ? theme.colors.surface.border.gray.subtle
        : theme.colors.feedback.border.positive.subtle
    };
    width: ${width}%;
    background: ${
      variant === 'grey'
        ? theme.colors.interactive.background.gray.faded
        : theme.colors.feedback.background.positive.subtle
    };
  `,
);

export const AmountText = styled.div<{ variant: string }>(
  ({ theme, variant }) => `
    font-size: ${theme.typography.fonts.size[400]}px;
    font-style: normal;
    font-weight: ${theme.typography.fonts.weight.bold};
    color: ${
      variant === 'grey'
        ? theme.colors.surface.text.gray.muted
        : theme.colors.feedback.text.positive.intense
    };
  `,
);

const CelebrationEmoji = styled.span(
  ({ theme }) => `
    font-size: ${theme.typography.fonts.size[600]}px;
    line-height: ${theme.typography.lineHeights[600]}px;
  `,
);

const PayableTaxPercent = ({ regime, tax, percent, variant, onClick }: PayableTaxPercentProps) => {
  return (
    (<PayableTaxWrapper variant={variant ?? 'grey'} width={percent} onClick={onClick}>
      <Box>
        <Text color="surface.text.gray.normal" size="large" weight="semibold">
          {regime}
        </Text>
      </Box>
      <AmountText variant={variant ?? 'grey'}>{toIndianCurrencyString(tax)}</AmountText>
      {variant === 'green' && (
        <Box position={'absolute'} right="-50px">
          <CelebrationEmoji aria-hidden="true">🤑</CelebrationEmoji>
        </Box>
      )}
    </PayableTaxWrapper>)
  );
};

export default PayableTaxPercent;
